import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { TableBody, TableRow } from '@mui/material';
import StyledTableCell from 'components/SummaryComponent/StyledTableCell';

import { formatDate, getNextWeekDay, getWeeksAdded } from 'utils/date';

function CardPackageComponent(props) {
  const FRIDAY = 5;
  const { pkg, startDate } = props;
  const packageStartDate = new Date(startDate);
  const packageEndDate = getNextWeekDay(
    getWeeksAdded(packageStartDate, pkg.courseWeeks - 1),
    FRIDAY
  );

  return (
    <TableBody>
      <TableRow>
        <StyledTableCell component="th" scope="row" colSpan={2}>
          {pkg.title}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          {ReactHtmlParser(pkg.miniDescription)}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Data de início
        </StyledTableCell>
        <StyledTableCell align="right">
          {formatDate(packageStartDate, 'forward-slash')}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Data de término
        </StyledTableCell>
        <StyledTableCell align="right">
          {formatDate(packageEndDate, 'forward-slash')}
        </StyledTableCell>
      </TableRow>
    </TableBody>
  );
}

export default CardPackageComponent;

CardPackageComponent.propTypes = {
  pkg: PropTypes.instanceOf(Object).isRequired,
  startDate: PropTypes.string.isRequired,
};
